export enum Iata {
    ACH = 'ACH',
    AMS = 'AMS',
    BER = 'BER',
    BLL = 'BLL',
    BRE = 'BRE',
    BRN = 'BRN',
    BRU = 'BRU',
    BSL = 'BSL',
    BTS = 'BTS',
    CGN = 'CGN',
    CRL = 'CRL',
    DRS = 'DRS',
    DTM = 'DTM',
    DUS = 'DUS',
    EIN = 'EIN',
    ERF = 'ERF',
    FDH = 'FDH',
    FKB = 'FKB',
    FMM = 'FMM',
    FMO = 'FMO',
    FRA = 'FRA',
    GRQ = 'GRQ',
    GRZ = 'GRZ',
    GVA = 'GVA',
    GWT = 'GWT',
    HAJ = 'HAJ',
    HAM = 'HAM',
    HHN = 'HHN',
    INN = 'INN',
    KLU = 'KLU',
    KRK = 'KRK',
    KSF = 'KSF',
    LBC = 'LBC',
    LEJ = 'LEJ',
    LGG = 'LGG',
    LIN = 'LIN',
    LJU = 'LJU',
    LNZ = 'LNZ',
    LUG = 'LUG',
    LUX = 'LUX',
    MST = 'MST',
    MUC = 'MUC',
    MXP = 'MXP',
    NRN = 'NRN',
    NUE = 'NUE',
    PAD = 'PAD',
    PRG = 'PRG',
    RLG = 'RLG',
    SCN = 'SCN',
    STR = 'STR',
    SXB = 'SXB',
    SZG = 'SZG',
    VIE = 'VIE',
    WAW = 'WAW',
    ZRH = 'ZRH',
}
